<template>
  <header class="app-header" :class="{ 'app-header--inverse': inverse }">
    <div class="app-header__brand">
      <img class="app-header__brand-mark" :src="brandIcon" alt="" />
      <span class="app-header__brand-name">智谷优学</span>
    </div>
    <span class="app-header__page-title">{{ title }}</span>
    <mobile-menu-button class="app-header__menu-button" :icon="menuIcon" />
  </header>
</template>

<script>
import MobileMenuButton from '@/components/navigation/MobileMenuButton.vue'

export default {
  name: 'AppHeader',
  components: { MobileMenuButton },
  props: {
    title: {
      type: String,
      required: true
    },
    brandIcon: {
      type: String,
      required: true
    },
    menuIcon: {
      type: String,
      required: true
    },
    inverse: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.app-header {
  position: relative;
  display: flex;
  align-items: center;
  width: calc(100% - 20px);
  height: 49px;
  margin: 0 10px;
  color: #333;
}

.app-header--inverse {
  color: #fff;
}

.app-header__brand {
  display: flex;
  align-items: center;
  min-width: 82px;
}

.app-header__brand-mark {
  width: 19px;
  height: 19px;
  object-fit: contain;
}

.app-header__brand-name {
  margin-left: 4px;
  color: #1e40af;
  font-family: SourceHanSansCN-Bold, sans-serif;
  font-size: 15px;
  font-weight: 700;
  line-height: 19px;
  white-space: nowrap;
}

.app-header--inverse .app-header__brand-name {
  color: #fff;
}

.app-header__page-title {
  position: absolute;
  left: 50%;
  color: currentColor;
  font-family: SourceHanSansCN-Bold, sans-serif;
  font-size: 18px;
  font-weight: 700;
  line-height: 22px;
  white-space: nowrap;
  transform: translateX(-50%);
}

.app-header__menu-button {
  width: 18px;
  height: 16px;
  margin-left: auto;
}
</style>
